exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#campaign img {\n  width: 100%;\n}", ""]);

// exports
